import { Injectable, isDevMode } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LoggerService {
  constructor() { }
  private objToStr(obj:any):string {
    switch(typeof obj) {
      case "object":
        return JSON.stringify(obj);
      default:
        return obj.toString();
    }
  }
  public log(...objs:any[]) {
    if(isDevMode()) {
      console.log(...objs.map(o => this.objToStr(o)));
    }
  }
}
